export default __webpack_public_path__ + "static/burr-944ae10d9ad19af2d39651d28c4264de.png";